import {
  ChangeDetectorRef,
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { VesselDAO } from '../../../../../../core/services/dao/vesselDAO';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogsService } from '../../../../../../core/services/dialog.service';
import { UploadDAO } from '../../../../../../core/services/dao/uploadDAO';
import { UserDAO } from '../../../../../../core/services/dao/userDAO';
import * as moment from 'moment';
import { AdminAccess } from '../../../../../shared/accessAdmin';
import { ApiHelper } from '../../../../../../core/services/apiHelper';
import { CaptainDAO } from '../../../../../../core/services/dao/captainDAO';
import { ConstantMan } from '../../../../../../core/services/constantMan';
import { NumberFormatterService } from '../../../../../../core/services/number.formatter.service';
import { MatSelectChange } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { VesselImageDAO } from '../../../../../../core/services/dao/vesselImageDAO';
import { VesselImage } from 'anchor-shared/lib/model/entity/vesselImage';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { MooringLocationDAO } from '../../../../../../core/services/dao/mooringLocationDAO';
import { ContainsSubscriptions } from '../../../../../../core/services/interfaces/contains-subscriptions';
import { combineLatest } from 'rxjs';
import { VesselAvailabilityPreferencesDAO } from '../../../../../../core/services/dao/vesselAvailabilityPreferencesDAO';
import { unsubscribeFromAll } from '../../../../../../core/pure-functions/rx-helper';
import { Charter } from 'anchor-shared/lib/model/entity/charter';
import { LoggingDAO } from '../../../../../../core/services/dao/loggingDAO';
import { WaterBodyDAO } from '../../../../../../core/services/dao/waterBodyDAO';
import { VesselAvailabilityDAO } from '../../../../../../core/services/dao/VesselAvailabilityDAO';
import { take } from 'rxjs/operators';
import { EnvironmentalMediaService } from '../../../../../../core/services/environmental-media.service';
import { buildRouteEnding } from '../../../../../../core/pure-functions/navigation/buyflow-vessel-route-builder/buyflow-vessel-route-builder';
import { MooringLocation } from 'anchor-shared/lib/model/entity/mooringLocation';

@Component({
  selector: 'app-vessel-edit',
  templateUrl: './vessel-edit.component.html',
  styleUrls: ['./vessel-edit.component.scss'],
})
export class VesselEditComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  @ViewChild('vesselForm') public vesselForm: NgForm;

  model: Vessel = {} as Vessel;
  charters: Charter[];
  showAdvanced = false;
  features: any[] = [];
  selectedWaterBodies = [];
  selectedCaptainsIds: number[] = [];
  waterBodiesChanged = false;
  mooringLocationChanged = false;
  currentCaptainIds = [];
  captainsListChanged = false;
  formSub: Subscription;
  tabs = ConstantMan.VESSEL_FORM_TABS_ARRAY;
  tabDefs = ConstantMan.VESSEL_FORM_TABS;
  selectedTab = this.tabDefs.BOAT_INFORMATION;
  insuranceFiles = [];
  public user;
  days: number[] = [];
  months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  queryParamIndex: number;
  years = [];
  insExpError: string;
  userId: number;
  changed = false;
  isAdmin = false;
  canSubmit: boolean;
  canSave: boolean;
  canRequestEdit: boolean;
  isActive: boolean;
  disabled: boolean;
  vesselImagesToSave: VesselImage[];
  isMobile: boolean;
  mooringLocation: MooringLocation;
  subs: Subscription[] = [];
  showEditRequest = false;
  editRequestSubmitted = false;
  modelSaving: boolean;
  linkToListingPage: string;

  constructor(
    private vesselDAO: VesselDAO,
    private route: ActivatedRoute,
    private router: Router,
    private uploadDAO: UploadDAO,
    public dialog: DialogsService,
    private userDao: UserDAO,
    private captainDao: CaptainDAO,
    private adminAccess: AdminAccess,
    private apiHelper: ApiHelper,
    private formatter: NumberFormatterService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    private vesselImageDAO: VesselImageDAO,
    private breakpointObserver: BreakpointObserver,
    private mooringLocationDao: MooringLocationDAO,
    private vesselPreferencesDAO: VesselAvailabilityPreferencesDAO,
    private readonly loggingDAO: LoggingDAO,
    private waterBodyDAO: WaterBodyDAO,
    private vesselAvailabilityDAO: VesselAvailabilityDAO,
    private environmentalMediaService: EnvironmentalMediaService,
  ) {
    for (let i = 0; i < 31; ++i) {
      this.days.push(i + 1);
    }
    for (let i = 0; i < 10; ++i) {
      this.years.push(moment().year() + i);
    }
    this.insExpError = '';
    this.user = this.userDao.getCurrentUser();
    this.userId = this.user.id;
    this.user.roles.map((role) => {
      if (role.adminAccess) {
        this.isAdmin = true;
      }
    });
    const breakpointSub = this.breakpointObserver
      .observe(['(min-width: 960px)'])
      .subscribe((state: BreakpointState) => {
        this.isMobile = !state.matches;
      });
    this.subs.push(breakpointSub);
    this.readQueryParams();
    const routeSub = this.route.data.subscribe((data) => {
      this.model = data.portal.vesselResolve;
      if (this.model.status !== 'active') {
        this.selectedTab = this.tabDefs.BOAT_INFORMATION;
      } else {
        this.selectedTab = this.tabDefs.CHARTER_SCHEDULE;
      }
      this.charters = data.portal.charterResolve;
    });
    this.linkToListingPage = this.createLinkToListingPage();
    this.subs.push(routeSub);
  }

  selectTab(tab: string, index: number) {
    this.selectedTab = tab;
    this.changeUrl(tab, index);
    this.editRequestSubmitted = false;
    this.showEditRequest = false;
    this.tagTabChange(tab);
  }

  changeUrl(tab, index) {
    tab = tab.replace(/\s/g, '-').replace(/&/g, 'and');
    this.router
      .navigate(['.'], {
        relativeTo: this.route,
        queryParams: { index: index, tab: tab },
        queryParamsHandling: 'merge',
      })
      .catch((mergeQueryParamError) => {
        console.error(mergeQueryParamError);
      });
  }

  readQueryParams(): void {
    this.queryParamIndex = parseInt(
      this.route.snapshot.queryParamMap.get('index'),
      10,
    );
  }

  formatPrices() {
    this.model.cashValue = `${this.formatter.unMaskPrice(
      this.model.cashValue,
    )}`;
    this.model.fuelBillingRate = this.formatter.unMaskPrice(
      this.model.fuelBillingRate,
    );
    this.model.fuelReimbursementRate = this.formatter.unMaskPrice(
      this.model.fuelReimbursementRate,
    );
    this.model.fullDayPrice = this.formatter.unMaskPrice(
      this.model.fullDayPrice,
    );
    this.model.halfDayPrice = this.formatter.unMaskPrice(
      this.model.halfDayPrice,
    );
    this.model.additionalHours = this.formatter.unMaskPrice(
      this.model.additionalHours,
    );
    this.model.fullDayListPrice = this.formatter.unMaskPrice(
      this.model.fullDayListPrice,
    );
    this.model.halfDayListPrice = this.formatter.unMaskPrice(
      this.model.halfDayListPrice,
    );
    this.model.additionalHoursListPrice = this.formatter.unMaskPrice(
      this.model.additionalHoursListPrice,
    );
    this.model.depositAmount = this.formatter.unMaskPrice(
      this.model.depositAmount,
    );
  }

  saveVesselImages(primaryUrl: string): void {
    const primaryPhotoUpdated: boolean =
      this.model.primaryPhotoAbsPath === primaryUrl;
    this.model.primaryPhotoAbsPath = primaryUrl;
    this.vesselDAO
      .setPrimaryPhoto(this.model.id, primaryUrl)
      .subscribe((data) => {
        if (data && !primaryPhotoUpdated) {
          this.openSnackbar('Vessel Saved');
        } else if (data && primaryPhotoUpdated) {
          this.modelSaving = true;
          this.vesselAvailabilityDAO
            .updateFullAvailabilitiesForVessel(this.model.id)
            .pipe(take(1))
            .subscribe(() => {
              this.openSnackbar('Vessel saved and primary photo updated.');
              this.modelSaving = false;
            });
        }
      });
    if (this.vesselImagesToSave && this.vesselImagesToSave.length > 0) {
      const updates = [];
      this.vesselImagesToSave.forEach((image) => {
        if (image) {
          updates.push(this.vesselImageDAO.updateFromPartial(image.id, image));
        } else {
          updates.push(this.vesselImageDAO.updateFromPartial(image.id, image));
        }
      });
      combineLatest(updates).subscribe((completed) => {
        console.log('vessel images updated: ' + updates.length);
        this.vesselImagesToSave = [];
      });
    }
  }

  saveModel() {
    this.modelSaving = true;
    this.formatPrices();
    this.model.features = this.features;
    const updateSub = this.vesselDAO.serverUpdate(this.model).subscribe(
      (res) => {
        this.vesselAvailabilityDAO
          .updateFullAvailabilitiesForVessel(this.model.id)
          .pipe(take(1))
          .subscribe(() => {
            this.openSnackbar('Vessel Saved');
            this.modelSaving = false;
          });
        if (this.waterBodiesChanged) {
          const ids = [];
          this.selectedWaterBodies.forEach((wb) => {
            ids.push(wb.id);
          });
          const waterBodySub = this.vesselDAO
            .updateVesselWaterBodies(this.model.id, ids)
            .subscribe((data) => {});
          this.subs.push(waterBodySub);
        }
      },
      (err) => console.error(err),
    );
    this.subs.push(updateSub);
    this.logEvent();
  }

  setWaterBodiesChanged() {
    this.waterBodiesChanged = true;
  }

  setCaptainsChanged(currentCaptainIds: number[]) {
    this.currentCaptainIds = currentCaptainIds;
    this.captainsListChanged = true;
  }

  setMooringLocationChanged(location: any) {
    this.mooringLocationChanged = true;
  }

  setCanSubmit() {
    this.canSubmit = this.model.status === ConstantMan.VESSEL_STATUSES.DRAFT;
  }

  setCanSave() {
    this.canSave =
      this.model.status === ConstantMan.VESSEL_STATUSES.DRAFT ||
      this.model.status === ConstantMan.VESSEL_STATUSES.PENDING ||
      this.isAdmin;
  }

  setCanRequestEdit() {
    this.canRequestEdit =
      this.model.status === ConstantMan.VESSEL_STATUSES.ACTIVE ||
      this.model.status === ConstantMan.VESSEL_STATUSES.ACTIVE ||
      this.model.status === ConstantMan.VESSEL_STATUSES.INACTIVE;
  }

  setIsActive() {
    this.isActive = this.model.status === ConstantMan.VESSEL_STATUSES.ACTIVE;
  }

  setStatusProps() {
    this.setCanSubmit();
    this.setCanSave();
    this.setCanRequestEdit();
    this.setIsActive();
  }

  showRequestEditForBoatOwner() {
    // show Request Edit button only on Select tabs for Boat Owner
    if (this.isAdmin || this.canSave) {
      return false;
    } else if (
      this.selectedTab === this.tabDefs.CAPTAIN_INFO &&
      this.canRequestEdit
    ) {
      return true;
    }
    return false;
  }

  public loadSelectedVesselWaterBodies(boat: Vessel): void {
    let waterBodiesIds = boat.vesselWaterBodyMap.map((wb) => wb.waterBodyId);
    const wbSub = this.waterBodyDAO
      .getWaterBodiesForVessel(waterBodiesIds)
      .subscribe((waterBodies) => {
        this.selectedWaterBodies = waterBodies;
      });
    this.subs.push(wbSub);
  }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      const vesselPrefsSub = this.vesselPreferencesDAO
        .findByVesselId(params.id)
        .subscribe((vesselPrefs) => {
          this.model.vesselAvailabilityPreferences = vesselPrefs;
          this.setStatusProps();
          this.disabled =
            this.model.status === ConstantMan.VESSEL_STATUSES.ACTIVE ||
            this.model.status === ConstantMan.VESSEL_STATUSES.INACTIVE;
          if (this.isAdmin) {
            this.disabled = false;
          }
          this.features = this.model.features
            ? this.formatter.parseArrayFromJson(this.model.features)
            : [];
          this.user.roles.map((role) => {
            if (role.adminAccess) {
              this.isAdmin = true;
            }
          });
          this.loadSelectedVesselWaterBodies(this.model);
          this.model.vesselCaptainMap.forEach((captain) => {
            this.selectedCaptainsIds.push(captain.captainId);
          });
          if (
            this.model.captainId &&
            this.model.captainId !== this.user.captain.id
          ) {
            this.adminAccess.checkAdminAccess(
              this.userDao,
              this.apiHelper,
              this.router,
            );
            this.captainDao
              .loadById(this.model.captainId)
              .subscribe((result) => {
                this.user = result.user;
              });
          }
          if (this.queryParamIndex) {
            this.selectedTab = this.tabs[this.queryParamIndex];
          }
        });
      this.subs.push(vesselPrefsSub);
    });
  }

  getHubspotDataForBoatApprovalRequest(): any {
    return {
      boatOwnerEmail: this.user.email,
      boatOwnerName: this.user.firstName + ' ' + this.user.lastName,
      boatOwnerPhone: this.user.phoneNumber,
      vesselId: this.model.id,
    };
  }

  sendApprovalRequest() {
    const hubspotData = this.getHubspotDataForBoatApprovalRequest();
    this.vesselDAO
      .sendApprovalRequest(hubspotData)
      .subscribe((vessel: Vessel) => {
        this.model = vessel;
        this.setStatusProps();
        this.openSnackbar('Approval request sent');
      });
  }

  openSnackbar(message: string) {
    this.snackBar.open(message, null, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  logEvent() {
    if (!this.isAdmin && !this.canSave) {
      const vesselLogSub = this.vesselDAO
        .logSaveFromBoatOwner(this.selectedTab, this.model)
        .subscribe(() => {});
      this.subs.push(vesselLogSub);
    }
  }

  activate() {
    this.vesselDAO
      .setStatus(this.model.id, ConstantMan.VESSEL_STATUSES.ACTIVE)
      .subscribe(() => {
        this.isActive = true;
        this.model.status = ConstantMan.VESSEL_STATUSES.ACTIVE;
        this.vesselAvailabilityDAO
          .updateFullAvailabilitiesForVessel(this.model.id)
          .pipe(take(1))
          .subscribe();
        this.openSnackbar('Vessel status updated');
      });
  }

  deactivate() {
    this.vesselDAO
      .setStatus(this.model.id, ConstantMan.VESSEL_STATUSES.INACTIVE)
      .subscribe(() => {
        this.isActive = false;
        this.model.status = ConstantMan.VESSEL_STATUSES.INACTIVE;
        this.vesselAvailabilityDAO
          .deleteAvailabilitiesForVessel(this.model.id)
          .pipe(take(1))
          .subscribe();
        this.openSnackbar('Vessel status updated');
      });
  }

  showRequestEditForm() {
    this.showEditRequest = true;
  }

  hideRequestEditForm() {
    this.showEditRequest = false;
    this.editRequestSubmitted = true;
  }

  ngOnDestroy(): void {
    if (this.formSub) {
      this.formSub.unsubscribe();
    }
    unsubscribeFromAll(this.subs);
  }

  keepThese(vesselImageToKeepTrackOf: VesselImage): void {
    if (!this.vesselImagesToSave) {
      this.vesselImagesToSave = [];
    }
    this.vesselImagesToSave.push(vesselImageToKeepTrackOf);
  }

  onSubmit() {
    this.vesselDAO.serverUpdate(this.model).subscribe(
      () => {
        if (this.changed) {
          this.changed = false;
        }
        if (this.isAdmin) {
          this.router.navigate(['manage/admin/vessels']);
        } else {
          this.router.navigate(['manage/boatyard']);
        }
      },
      (err) => console.error(err),
    );
  }

  back() {
    if (this.isAdmin) {
      this.router.navigate(['manage/admin/vessels']);
    } else {
      this.router.navigate(['manage/boatyard']);
    }
  }

  delete() {
    if (this.isAdmin) {
      this.dialog.DeleteDialog(this.model.name).subscribe((result) => {
        if (result) {
          this.vesselDAO.serverDelete(this.model).subscribe(
            () => {
              this.router.navigate(['manage/admin/vessels']);
            },
            (err) => console.error(err),
          );
        }
      });
    }
  }

  toggleAdvanced() {
    this.showAdvanced = !this.showAdvanced;
  }

  onChange() {
    this.changed = true;
  }

  onTabChange(event: MatSelectChange): void {
    this.selectedTab = event.value;
    this.editRequestSubmitted = false;
    this.showEditRequest = false;
  }

  navigateToUserInfo(): void {
    if (this.userDao.currentUserIsAdmin()) {
      this.router.navigate([
        'manage/admin/user/edit/' + this.model.owner.userId,
      ]);
    } else {
      this.router.navigate(['manage']);
    }
  }

  private tagTabChange(tab: string): void {
    this.loggingDAO.serverTag({
      name: 'Edit Vessel Tab Change',
      className: this.constructor.name,
      description:
        'Tab changed occurred on the vessel edit screen for any role.',
      ancillary: {
        tabName: tab,
        isAdmin: this.isAdmin,
        vesselId: this.model ? this.model.id : null,
      },
    });
  }

  private createLinkToListingPage() {
    if (!this.model.make) return;
    return `${this.environmentalMediaService.getClientBaseURL()}vessels/yacht-and-boat-rentals/${buildRouteEnding(
      this.model,
    )}`;
  }
}
